// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserRagPlayground .page-container {
  margin-bottom: 32px;
}
#AdminUserRagPlayground .base-card {
  border-radius: 8px;
  height: calc(100vh - 96px - 64px);
  position: relative;
}
#AdminUserRagPlayground .base-card .clear-button {
  width: 120px;
  position: absolute;
  right: 32px;
  top: 32px;
  z-index: var(--z-index-local-over-3);
  background-color: var(--white-color-lightest);
}
#AdminUserRagPlayground .base-card .clear-button:hover {
  background-color: var(--white-color-light);
}
#AdminUserRagPlayground .list-area {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: scroll;
}
#AdminUserRagPlayground .chat-area {
  height: calc(100% - 130px);
  overflow: auto;
  z-index: var(--z-index-local-default);
  margin-top: 50px;
  margin-bottom: 80px;
}
#AdminUserRagPlayground .chat-area::-webkit-scrollbar {
  display: none;
}
#AdminUserRagPlayground .chat-user {
  text-align: left;
}
#AdminUserRagPlayground .chat-user:not(:first-child) {
  margin-top: 64px;
}
#AdminUserRagPlayground .chat-assistant {
  text-align: left;
}
#AdminUserRagPlayground .chat-assistant-message {
  text-align: left;
  padding: 0 34px;
}
#AdminUserRagPlayground .chat-icon {
  margin: 0 5px;
}
#AdminUserRagPlayground .chat-text {
  padding-left: 5px;
  max-width: 1000px;
}
#AdminUserRagPlayground .reference-image-list {
  overflow-x: auto;
}
#AdminUserRagPlayground .reference-image-list .reference-image {
  min-width: 150px;
  max-width: 150px;
  min-height: 100px;
  max-height: 100px;
}
#AdminUserRagPlayground .reference-image-list .card-input-area {
  padding: 0;
  overflow: hidden;
  border: solid 1px var(--border-color);
  border-radius: 10px;
  margin: 5px;
  position: relative;
}
#AdminUserRagPlayground .reference-image-list .card-input-area .card-content {
  overflow: hidden;
}
#AdminUserRagPlayground .chat-input-area {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 8px;
  overflow: hidden;
  border: solid 1px var(--border-color);
  max-width: 720px;
  max-height: 360px;
  min-height: 64px;
  z-index: var(--z-index-local-over-2);
  transition: box-shadow 0.3s;
}
#AdminUserRagPlayground .chat-input-area.empty {
  bottom: 0;
  top: 0;
  margin: auto;
}
#AdminUserRagPlayground .chat-input-area:hover {
  box-shadow: var(--omni-shadow-hidden);
}
#AdminUserRagPlayground .chat-input-area .textinput {
  border: none;
  padding-right: 64px;
}
#AdminUserRagPlayground .chat-input-area .tag-input {
  padding-right: 48px;
  min-width: 280px;
}
#AdminUserRagPlayground .chat-input-area .send-button {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: none 0px var(--border-color);
  background-color: var(--primary-color-main);
  color: var(--white-color-light);
}
#AdminUserRagPlayground .chat-input-area .send-button:hover {
  background-color: var(--primary-color-dark);
}
#AdminUserRagPlayground .chat-input-area .send-button.disabled {
  background-color: var(--primary-color-disabled);
  color: var(--white-color-light);
}
#AdminUserRagPlayground .chat-input-area *::-webkit-scrollbar {
  display: none;
}
#AdminUserRagPlayground .reference-sources-list {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: calc(100vw - var(--menu-current-width) - 120px);
  flex-wrap: nowrap;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area {
  min-width: 232px;
  max-width: 232px;
  padding: 0;
  overflow: hidden;
  height: fit-content;
  border: solid 1px var(--border-color);
  border-radius: 10px;
  margin: 5px;
  position: relative;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .card-content {
  overflow: hidden;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .title {
  height: 80px;
  background-color: var(--white-color-light);
  border-bottom: solid 1px var(--border-color);
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .title .title-content-area {
  height: 44px;
  padding-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .detail {
  width: 100%;
  height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .detail::-webkit-scrollbar {
  display: none;
}
#AdminUserRagPlayground .reference-sources-list .card-input-area .detail .detail-content-area {
  height: auto;
  padding-bottom: 16px;
  overflow: visible;
  word-break: break-word;
  overflow-wrap: anywhere;
}
#AdminUserRagPlayground .tool-tip-float {
  width: auto;
}
#AdminUserRagPlayground .chat-loading {
  height: 120px;
  width: 100%;
}
#AdminUserRagPlayground .chat-loading .loading-dot {
  width: 12px;
  height: 12px;
  background-color: var(--dark-color-light);
  border-radius: 50%;
  /* 円形 */
  animation: loading-dots 1.5s infinite ease-in-out;
}
#AdminUserRagPlayground .chat-loading .loading-dot:nth-child(2) {
  animation-delay: 0.2s;
  /* 2つ目のドットの遅延 */
}
#AdminUserRagPlayground .chat-loading .loading-dot:nth-child(3) {
  animation-delay: 0.4s;
  /* 3つ目のドットの遅延 */
}
@keyframes loading-dots {
  0%, 80%, 100% {
    transform: scale(0);
    /* 小さくする */
    opacity: 0.5;
    /* 透明度を少し下げる */
  }
  40% {
    transform: scale(1);
    /* 元のサイズ */
    opacity: 1;
    /* 完全に表示 */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserRagPlayground.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACZ;EACI,mBAAA;AACR;AAEI;EACI,kBAAA;EACA,iCAAA;EAEA,kBAAA;AADR;AAGQ;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oCAAA;EACA,6CAAA;AADZ;AAGY;EACI,0CAAA;AADhB;AAMI;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;AAJR;AAOI;EACI,0BAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAMQ;EACI,aAAA;AAJZ;AAQI;EACI,gBAAA;AANR;AAQQ;EACI,gBAAA;AANZ;AAUI;EACI,gBAAA;AARR;AAUI;EACI,gBAAA;EACA,eAAA;AARR;AAWI;EACI,aAAA;AATR;AAYI;EACI,iBAAA;EACA,iBAAA;AAVR;AAaI;EACI,gBAAA;AAXR;AAaQ;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAXZ;AAcQ;EACI,UAAA;EACA,gBAAA;EAEA,qCAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAbZ;AAeY;EACI,gBAAA;AAbhB;AAmBI;EACI,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EAQA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,2BAAA;AAxBR;AAWQ;EACI,SAAA;EACA,MAAA;EACA,YAAA;AATZ;AAqBQ;EACI,qCAAA;AAnBZ;AAsBQ;EACI,YAAA;EACA,mBAAA;AApBZ;AAuBQ;EACI,mBAAA;EACA,gBAAA;AArBZ;AAwBQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,2CAAA;EACA,+BAAA;AAvBZ;AAyBY;EACI,2CAAA;AAvBhB;AA2BQ;EACI,+CAAA;EACA,+BAAA;AAzBZ;AA4BQ;EACI,aAAA;AA1BZ;AA8BI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,0DAAA;EACA,iBAAA;AA5BR;AA8BQ;EACI,gBAAA;EACA,gBAAA;EAEA,UAAA;EACA,gBAAA;EACA,mBAAA;EAEA,qCAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AA9BZ;AAgCY;EACI,gBAAA;AA9BhB;AAiCY;EACI,YAAA;EACA,0CAAA;EAEA,4CAAA;AAhChB;AAkCgB;EACI,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAhCpB;AAoCY;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAlChB;AAmCgB;EACI,aAAA;AAjCpB;AAoCgB;EACI,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;AAlCpB;AAwCI;EACI,WAAA;AAtCR;AAyCI;EACI,aAAA;EACA,WAAA;AAvCR;AAyCQ;EACI,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,OAAA;EACA,iDAAA;AAvCZ;AA0CQ;EACI,qBAAA;EACA,eAAA;AAxCZ;AA2CQ;EACI,qBAAA;EACA,eAAA;AAzCZ;AA6CI;EAEI;IAGI,mBAAA;IACA,UAAA;IACA,YAAA;IACA,cAAA;EA9CV;EAiDM;IACI,mBAAA;IACA,UAAA;IACA,UAAA;IACA,UAAA;EA/CV;AACF","sourcesContent":["#AdminUserRagPlayground{\r\n    .page-container {\r\n        margin-bottom: 32px;\r\n    }\r\n\r\n    .base-card{\r\n        border-radius: 8px;\r\n        height: calc(100vh - 96px - 64px);\r\n\r\n        position: relative;\r\n    \r\n        .clear-button{\r\n            width: 120px;\r\n            position: absolute;\r\n            right: 32px;\r\n            top: 32px;\r\n            z-index: var(--z-index-local-over-3);\r\n            background-color: var(--white-color-lightest);\r\n\r\n            &:hover{\r\n                background-color: var(--white-color-light);\r\n            }\r\n        }\r\n    }\r\n\r\n    .list-area{\r\n        max-height: 400px;\r\n        overflow-x: hidden;\r\n        overflow-y: scroll;\r\n    }\r\n\r\n    .chat-area {\r\n        height: calc(100% - 130px);\r\n        overflow: auto;\r\n        z-index: var(--z-index-local-default);\r\n        margin-top: 50px;\r\n        margin-bottom: 80px;\r\n        &::-webkit-scrollbar {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .chat-user{\r\n        text-align: left;\r\n\r\n        &:not(:first-child) {\r\n            margin-top: 64px;\r\n        }\r\n    }\r\n\r\n    .chat-assistant{\r\n        text-align: left;\r\n    }\r\n    .chat-assistant-message{\r\n        text-align: left;\r\n        padding: 0 34px;\r\n    }\r\n\r\n    .chat-icon{\r\n        margin: 0 5px;\r\n    }\r\n\r\n    .chat-text {\r\n        padding-left: 5px;\r\n        max-width: 1000px;\r\n    }\r\n\r\n    .reference-image-list{\r\n        overflow-x: auto;\r\n\r\n        .reference-image{\r\n            min-width: 150px;\r\n            max-width: 150px;\r\n            min-height: 100px;\r\n            max-height: 100px;\r\n        }\r\n\r\n        .card-input-area {\r\n            padding: 0;\r\n            overflow: hidden;\r\n\r\n            border: solid 1px var(--border-color);\r\n            border-radius: 10px;\r\n            margin: 5px;\r\n            position: relative;\r\n\r\n            .card-content {\r\n                overflow: hidden;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .chat-input-area {\r\n        position: absolute;\r\n        bottom: 40px;\r\n        left: 0;\r\n        right: 0;\r\n        margin: auto;\r\n\r\n        &.empty {\r\n            bottom: 0;\r\n            top: 0;\r\n            margin: auto;\r\n        }\r\n\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n        border: solid 1px var(--border-color);\r\n        max-width: 720px;\r\n        max-height:360px;\r\n        min-height:64px;\r\n        z-index: var(--z-index-local-over-2);\r\n        transition: box-shadow 0.3s;\r\n\r\n        &:hover {\r\n            box-shadow: var(--omni-shadow-hidden);\r\n        }\r\n\r\n        .textinput {\r\n            border: none;\r\n            padding-right: 64px;\r\n        }\r\n\r\n        .tag-input {\r\n            padding-right: 48px;\r\n            min-width: 280px;\r\n        }\r\n\r\n        .send-button {\r\n            position: absolute;\r\n            bottom: 12px;\r\n            right: 12px;\r\n\r\n            width: 40px;\r\n            height: 40px;\r\n            border-radius: 6px;\r\n            border: none 0px var(--border-color);\r\n            background-color: var(--primary-color-main);\r\n            color: var(--white-color-light);\r\n\r\n            &:hover {\r\n                background-color: var(--primary-color-dark);\r\n            }\r\n        }\r\n\r\n        .send-button.disabled {\r\n            background-color: var(--primary-color-disabled);\r\n            color: var(--white-color-light);\r\n        }\r\n\r\n        *::-webkit-scrollbar {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .reference-sources-list {\r\n        display: flex;\r\n        flex-direction: row;\r\n        overflow-x: auto;\r\n        overflow-y: hidden;\r\n        width: 100%;\r\n        max-width: calc(100vw - var(--menu-current-width) - 120px);\r\n        flex-wrap: nowrap;\r\n\r\n        .card-input-area {\r\n            min-width: 232px;\r\n            max-width: 232px;\r\n\r\n            padding: 0;\r\n            overflow: hidden;\r\n            height: fit-content;\r\n\r\n            border: solid 1px var(--border-color);\r\n            border-radius: 10px;\r\n            margin: 5px;\r\n            position: relative;\r\n\r\n            .card-content{\r\n                overflow: hidden;\r\n            }\r\n\r\n            .title{\r\n                height: 80px;\r\n                background-color: var(--white-color-light);\r\n                // color: var(--white-color-lightest);\r\n                border-bottom: solid 1px var(--border-color);\r\n\r\n                .title-content-area{\r\n                    height: 44px;\r\n                    padding-bottom: 16px;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                }\r\n            }\r\n\r\n            .detail {\r\n                width: 100%;\r\n                height: 200px;\r\n                overflow-y: auto;\r\n                overflow-x: hidden;\r\n                text-overflow: ellipsis;\r\n                &::-webkit-scrollbar {\r\n                    display: none;\r\n                }\r\n\r\n                .detail-content-area{\r\n                    height: auto;\r\n                    padding-bottom: 16px;\r\n                    overflow: visible;\r\n                    word-break: break-word;\r\n                    overflow-wrap: anywhere;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .tool-tip-float{\r\n        width: auto;\r\n    }\r\n\r\n    .chat-loading {\r\n        height: 120px;\r\n        width: 100%;\r\n\r\n        .loading-dot {\r\n            width: 12px;\r\n            height: 12px;\r\n            background-color: var(--dark-color-light);\r\n            border-radius: 50%;\r\n            /* 円形 */\r\n            animation: loading-dots 1.5s infinite ease-in-out;\r\n        }\r\n    \r\n        .loading-dot:nth-child(2) {\r\n            animation-delay: 0.2s;\r\n            /* 2つ目のドットの遅延 */\r\n        }\r\n    \r\n        .loading-dot:nth-child(3) {\r\n            animation-delay: 0.4s;\r\n            /* 3つ目のドットの遅延 */\r\n        }\r\n    }\r\n\r\n    @keyframes loading-dots {\r\n\r\n        0%,\r\n        80%,\r\n        100% {\r\n            transform: scale(0);\r\n            /* 小さくする */\r\n            opacity: 0.5;\r\n            /* 透明度を少し下げる */\r\n        }\r\n\r\n        40% {\r\n            transform: scale(1);\r\n            /* 元のサイズ */\r\n            opacity: 1;\r\n            /* 完全に表示 */\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
